function HomeContainer({ children, className = "" }) {
    return (
        <div
            className={`home-container ${className}`.trim()}
        >
            {children}
        </div>
    );
}

export default HomeContainer;